import {Counter} from "./sandbox/Counter";
import {Home} from "./components/Home";
import {Problems} from "./components/Problems";
import {Practice} from "./components/Practice";
import {Subject} from "./components/Subject";
import {Sandbox} from "./sandbox/Sandbox";
import {Streak} from "./components/Streak";
import {Rush} from "./components/Rush";
import {About} from "./components/About";
import {Profile} from "./components/Profile";
import {Simulations} from "./components/simulation/Simulations";
import {PracticeTemplate} from "./components/PracticeTemplate";

const AppRoutes = [
    {
        index: true,
        element: <Home/>
    },
    {
        path: '/counter',
        element: <Counter/>
    },
    {
        path: '/problems',
        element: <Problems/>
    },
    {
        path: '/practice/*',
        element: <Practice/>
    },
    {
        path: '/subject/:id',
        element: <Subject/>
    },
    {
        path: '/sandbox',
        element: <Sandbox/>
    },
    {
        path: '/streak/*',
        element: <Streak/>
    },
    {
        path: '/rush/*',
        element: <Rush/>
    },
    {
        path: '/about',
        element: <About/>
    },
    {
        path: '/profile',
        element: <Profile/>
    },
    {
        path: '/simulations',
        element: <Simulations/>
    },
    {
        path: '/practicetemplate/*',
        element: <PracticeTemplate/>
    }
];

export default AppRoutes;
